<template>
    <div>
        <md-toolbar class="md-transparent py-0 px-3" md-elevation="0">
            <div class="md-layout md-gutter">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                    </div>
                    <h4 class="title">Modification de la journée : <span class="font-medium">{{ $moment(day.date).format('DD/MM/YYYY') }}</span></h4>
                </div>
                <div class="md-layout-actions md-layout-item md-size-20 text-right align-center">
                    <div class="flex items-center justify-end header-actions">
                        <div>
                            <md-button class="md-icon-button md-raised md-warning" @click="$emit('close')">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'times']"></font-awesome-icon>
                            </md-button>
                            <md-tooltip md-direction="top">Fermer</md-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </md-toolbar>
        <div class="px-3 mt-1 pb-3">
            <p class="text-sm mb-2"><span class="font-medium">Technicien : </span> {{ technician.fullName }}</p>
            <md-divider class="mt-2 mb-1"></md-divider>
            <template v-if="planningables.length > 0">
                <div v-for="(planningable, index) in planningables" :key="planningable.id" class="planningable mb-1">
                    <div v-if="showSector(index, planningable)" class="mb-1" :class="{'planningable-with-sector': showSector(index, planningable)}">
                        <span class="font-extrabold underline text-sm">{{ site(planningable.intervention).sector.name }}</span>
                    </div>
                    <div v-else class="mb-2"></div>
                    <div class="flex items-center space-x-2 planningable-intervention">
                        <div class="case-select">
                            <md-checkbox v-model="transfer.interventions" :value="planningable.id"></md-checkbox>
                        </div>
	                    <div class="w-full">
		                    <div class="flex items-center space-x-2">
			                    <div v-if="site(planningable.intervention).id">
				                    <div class="square-tooltip cursor-pointer" :class="statusIntervention(planningable.intervention).color">
			                            <span v-if="planningable.intervention.planning_intervention_prevision_id"
			                                  class="font-medium leading-none">
			                                {{ dateInterventionPlan(planningable.intervention).month }}
			                            </span>
				                    </div>
				                    <md-tooltip md-direction="top" style="min-width: max-content !important;">
					                    <p class="mb-0">
						                    Client :
						                    <span class="font-medium">{{ site(planningable.intervention).client.name }}</span>
					                    </p>
					                    <p class="mb-0">
						                    Type d'intervention :
						                    <span class="font-medium">{{ planningable.intervention.intervention_type.name }}</span>
					                    </p>
					                    <p class="mb-0">
						                    Catégorie d'intervention :
						                    <span class="font-medium">{{ planningable.intervention.category.name }}</span>
					                    </p>
				                    </md-tooltip>
			                    </div>
			                    <p class="text-xs">
				                    {{ site(planningable.intervention).name }}
				                    ({{ planningable.time.duration }})
			                    </p>
		                    </div>
		                    <div class="md-layout md-gutter">
			                    <div class="md-layout-item md-size-30">
				                    <md-field class="md-invalid mt-0">
					                    <md-input type="time" v-model="planningable.time.start" />
				                    </md-field>
			                    </div>
			                    <div class="md-layout-item md-size-30 pr-0">
				                    <md-field class="md-invalid mt-0">
					                    <md-input type="time" v-model="planningable.time.end" />
				                    </md-field>
			                    </div>
		                    </div>
		                    <div class="md-invalid relative mb-1">
			                    <validation-error :errors="apiValidationErrors[`plannings.${index}.start_date`]" />
		                    </div>
	                    </div>
                    </div>
                </div>
                <div class="md-invalid relative mt-3 mb-6" v-if="apiValidationErrors.plannings">
                    <validation-error :errors="apiValidationErrors.plannings" />
                </div>
                <md-divider class="mt-3 mb-2"></md-divider>
                <div class="panel-actions">
                    <form @submit.prevent="transferSelectedInterventions">
                        <p class="text-sm mb-1"><span class="font-medium">Transfert</span></p>
                        <div class="case-select">
                            <md-checkbox v-model="transfer.all" @change="toggleCheckAllInterventions($event)">Cocher toutes les interventions</md-checkbox>
                        </div>
                        <div class="md-layout md-gutter mt-2">
                            <div class="md-layout-item md-size-65">
                                <div class="md-multiselect">
                                    <label>Techniciens *</label>
                                    <multiselect v-model="transfer.technician"
                                                 :options="technicians"
                                                 :show-labels="false"
                                                 label="full_name"
                                                 track-by="full_name"
                                                 placeholder="Technicien">
                                        <template slot="noOptions">La liste est vide</template>
                                        <template slot="noResult">Aucun élement correspondant</template>
                                    </multiselect>
                                    <validation-error :errors="apiValidationErrors['to.technician_id']" />
                                </div>
                            </div>
                            <div class="md-layout-item md-size-35">
	                            <md-field class="md-invalid">
		                            <md-input type="date" v-model="transfer.date" />
		                            <validation-error :errors="apiValidationErrors['to.date']" />
	                            </md-field>
                            </div>
                        </div>
                        <div class="mt-3">
	                        <md-button class="md-icon-button md-raised md-success" type="submit">
		                        <font-awesome-icon class="md-icon" :icon="['fa', waiting ? 'sync-alt' : 'exchange-alt']" :class="{'animate-spin': waiting}"></font-awesome-icon>
		                        <span class="leading-none font-medium ml-2"> Transférer</span>
	                        </md-button>
                        </div>
                    </form>
                </div>
            </template>
            <p class="text-sm" v-else>Aucune intervention pour cette journée</p>
        </div>
    </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

import dateTimeFormattingMixin from "@/mixins/date-time-formatting-mixin"

export default {
    name: "PanelTransferInterventions",
    components: { ValidationError },
    mixins: [formMixin, dateTimeFormattingMixin],
    props: {
        day: Object,
        plannings: Array,
        isConflict: Boolean,
        technician: Object
    },
    data() {
        return {
            planningables: [],
            technicians: [],
            transfer: {
                interventions: [],
                all: false,
                technician: null,
                date: this.day.date
            },
	        waiting: false
        }
    },
    methods: {
        async getTechnicians() {
            const { data } = await this.$store.dispatch('users/getTechnicians', {
                isActive: false,
                order: 'order',
                separation: true
            })
            this.technicians = data
	        this.transfer.technician = data.find(technician => technician.id === this.technician.id)
        },
        formatPlannings() {
            let plannings = _.cloneDeep(this.plannings)
            plannings.map(planningable => {
                let minutes = (this.$moment.duration(this.$moment(planningable.end_date).diff(this.$moment(planningable.start_date)))).asMinutes()
                planningable.time = {
                    start: this.$moment(planningable.start_date).format('HH:mm'),
                    end: this.$moment(planningable.end_date).format('HH:mm'),
                    duration: this.hoursAndMinutes(minutes)
                }
            })
            this.planningables = plannings
        },
        searchPreviousIntervention(indexCurrentIntervention) {
            let index = 1
            let previousPlanning = this.plannings[indexCurrentIntervention - index]
            while(!previousPlanning.intervention && (indexCurrentIntervention - index >= 0)) {
                index++
                previousPlanning = this.plannings[indexCurrentIntervention - index]
            }
            return previousPlanning
        },
        statusIntervention(intervention) {
            let status = { text: intervention.status.name, color: '' }
            switch (intervention.status_id) {
                case 1:
                    status.color = 'danger'
                    break
                case 2:
                    status.color = 'warning'
                    break
                case 3:
                    status.color = 'yellow'
                    break
                case 4:
                    status.color = 'success'
                    break
                default:
                    status.color = 'black'
                    break
            }
            return status
        },
        dateInterventionPlan(intervention, format = false) {
            let month = intervention.planning_intervention_prevision.month + 1
            if(format) {
                month = month.toString().length === 1 ? '0' + month : month
            }
            return {
                year: this.$moment(this.day.date).format('YYYY'),
                month: month
            }
        },
        showSector(index, planningable) {
            return ((!this.plannings[(index - 1)] || !this.plannings[(index - 1)].intervention) ||
                (this.plannings[(index - 1)]
                    && !this.sameSector(this.searchPreviousIntervention(index).intervention, planningable.intervention)
                )
            )
        },
        sameSector(previousIntervention, currentIntervention) {
            let previousSector = this.site(previousIntervention).sector
            let currentSector = this.site(currentIntervention).sector
            if(!previousSector || !currentSector) {
                return false
            } else {
                return previousSector.id === currentSector.id
            }
        },
        toggleCheckAllInterventions(value) {
            if(value) {
                this.transfer.interventions = []
                this.planningables.map(planning => {
                    this.transfer.interventions.push(planning.id)
                })
            } else {
                this.transfer.interventions = []
            }
        },
        site(intervention) {
            let site = { id: null, name: 'Pas de site', address: {}, client: {}, sector: {} }
            if(intervention.site) {
                site = intervention.site ?? { id: null, name: 'Pas de site', address: {}, client: {}, sector: {} }
            } else {
                let contract = intervention?.planning_intervention_prevision?.planning_intervention_group?.planning_intervention?.contract
                site = contract.site ?? { id: null, name: 'Pas de site', address: {}, client: {}, sector: {} }
            }
            site.sector = site.sector ?? { name: 'Pas de secteur' }
            return site
        },
        async transferSelectedInterventions() {
	        if (!this.waiting) {
		        this.waiting = true
		        this.resetApiValidation()
		        const plannings = this.planningables.map(planningable => {
					if(this.transfer.interventions.find(planningIntervention => planningIntervention === planningable.id)) {
						const startTime = this.$moment(planningable.time.start, 'HH:mm').format('HH:mm:ss')
						const endTime = this.$moment(planningable.time.end, 'HH:mm').format('HH:mm:ss')
						return {
							id: planningable.id,
							start_date: startTime === 'Invalid date' ? this.$moment(planningable.start_date).format('HH:mm:ss') : startTime,
							end_date: endTime === 'Invalid date' ? this.$moment(planningable.end_date).format('HH:mm:ss') : endTime
						}
					}
		        }).filter(planning => {
					return planning !== undefined
		        })
		        try {
			        const { data } = await this.$store.dispatch('calendar/transferPanelSelectedInterventions', {
				        from: {
					        date: this.day.date,
					        weekNumber: this.day.weekNumber,
					        technician_id: this.technician.id,
				        },
				        to: {
					        date: this.transfer.date,
					        weekNumber: this.$moment(this.transfer.date).week(),
					        technician_id: this.transfer.technician ? this.transfer.technician.id : null
				        },
				        plannings: plannings
			        })
			        await this.$store.dispatch('alerts/success', 'Transfert effectué')
			        bus.$emit('updated-panel', data)
			        this.$emit('close')
		        } catch (e) {
			        this.setApiValidation(e.response.data.errors)
		        } finally {
					this.waiting = false
				}
	        }
        },
    },
    mounted() {
        this.formatPlannings()
        this.getTechnicians()
    },
    watch: {
        day: {
            deep: true,
            handler() {
                this.formatPlannings()
            }
        },
        plannings: {
            deep: true,
            handler() {
                this.formatPlannings()
            }
        }
    }
}
</script>

<style scoped lang="scss">
.square-tooltip {
    width: 13px;
    height: 13px;
    border-radius: 3px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    &.danger {
        background-color: $brand-primary;
    }
    &.success {
        background-color: $brand-success;
    }
    &.warning {
        background-color: $brand-warning;
    }
    &.yellow {
        background-color: $yellow-A700;
    }
    &.black {
        background-color: $black;
    }
    span {
        font-size: .6rem;
        line-height: .9rem;
    }
}

.case-select {
    max-height: 20px !important;

    ::v-deep {
        .md-checkbox {
            margin: 0 !important;

            .md-checkbox-container {
                width: 14px !important;
                min-width: 14px !important;
                height: 14px !important;

                &:before {
                    width: 20px !important;
                    height: 20px !important;
                }

                &:after {
                    width: 4px !important;
                    height: 10px !important;
                    left: 4px !important;
                }

                .md-ripple {
                    width: 20px !important;
                    height: 20px !important;
                }
            }

            .md-checkbox-label {
                font-size: .75rem;
                color: $black-color;
                font-weight: 400;
                height: 14.5px;
                line-height: 14px;
            }
        }
    }
}
</style>
